module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-video-fill-25e59c98.svg";